import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import selectn from "selectn";
import qs from "qs";

import TopStories from "dashboard/components/TopStories";
import {
  getStoriesStream,
  loadRevision,
  loadLatest,
  setStoryStream,
} from "actions/storiesStream";
import { getLocalItem } from "utils/localdb";
import analytics from "utils/analytics";

class StoryPermalink extends React.Component {
  constructor(props) {
    super(props);
    this.loadNextPage = this._loadNextPage.bind(this);
  }

  componentDidMount() {
    const params = qs.parse(this.props.location.search.slice(1));
    if (!this.props.stream.results.length || params.preview) {
      this.loadStream(this.props);
    } else if (this.props.stream.results && this.props.stream.results.length) {
      analytics.storyPageView(this.props.stream.results[0]); // call analytics for SSRd page
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id || (this.props.stream.results.length  && !nextProps.stream.results.length)) {
      this.loadStream(nextProps);
    }
  }

  componentWillUnmount() {
    if (this.props.stream.results && this.props.stream.results.length) {
      this.props.setStoryStream([]);
    }
  }

  getStreamParams(props) {
    return { story: props.match.params.id };
  }

  loadStream(props) {
    const params = qs.parse(props.location.search.slice(1));
    const adminToken = getLocalItem("adminToken");
    if (params.preview && adminToken) {
      if (params.revision) {
        return this.props.loadRevision(props.match.params.id, params.revision, adminToken);
      } else {
        return this.props.loadLatest(props.match.params.id, adminToken);
      }
    }

    return this.props.getStoriesStream(this.getStreamParams(props)).then((stream) => {
      // Block default pageview in GTM and send a virtual pageview for permalink streams
      analytics.storyPageView(stream.payload[0]);
    });
  }

  _loadNextPage(page) {
    return this.props.getStoriesStream({
      page,
      ...this.getStreamParams(this.props),
    }, true);
  }

  render() {
    const story = this.props.stream.results[0];
    if (!story) return <TopStories />;

    const ogImage = selectn("social_image.crops.16x9.url", story) || selectn("primary_image.crops.16x9.url", story);
    const primaryTag = selectn("primary_tag.name", story);
    const additionalTags = story.tags.map((tag) => {
      return tag.name;
    });
    // stories converted from RM may not have primary tag
    const tagsForMeta = primaryTag ? [primaryTag, ...additionalTags].join(", ") : additionalTags.join(", ");

    return (
      <div>
        <Helmet>
          <title>{story.headline} - Axios</title>
          <meta property="og:url" content={story.permalink} />
          <link rel="canonical" href={story.permalink} />
          <meta property="og:title" content={story.og_headline || story.headline} />
          {story.og_description && <meta property="og:description" content={story.og_description} />}
          {story.og_description && <meta name="description" content={story.og_description} />}
          {ogImage && <meta property="og:image" content={ogImage} />}
          {tagsForMeta && <meta name="keywords" content={tagsForMeta} />}
        </Helmet>

        <TopStories
          permalinkId={this.props.match.params.id}
          loadNextPage={this.loadNextPage}
          onlyShowSectionForA11y={true}
        />
      </div>
    );
  }
}

StoryPermalink.propTypes = {
  stream: PropTypes.shape({
    results: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.string.isRequired,
        permalink: PropTypes.string.isRequired,
        og_description: PropTypes.string,
        og_image: PropTypes.object,
        primary_image: PropTypes.object,
        primary_tag: PropTypes.object,
        tags: PropTypes.arrayOf(PropTypes.object),
      })
    ).isRequired,
  }),
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }),
  getStoriesStream: PropTypes.func.isRequired,
  loadLatest: PropTypes.func,
  loadRevision: PropTypes.func,
};

const mapStateToProps = (state) => ({
  stream: state.storiesStream,
});

const mapDispatchToProps = {
  getStoriesStream,
  loadLatest,
  loadRevision,
  setStoryStream,
};

export default connect(mapStateToProps, mapDispatchToProps)(StoryPermalink);



// WEBPACK FOOTER //
// ./src/dashboard/containers/StoryPermalink/StoryPermalink.js